import { Link } from 'react-router-dom';
import {
	TUITION_SEASON_TOTAL_LABEL,
	TUITION_INSTALLMENTS,
} from './seasonData';

// Single source of truth for FAQ content. Answers may be a string or JSX.
//
// IMPORTANT: answers that touch a policy give a short, friendly answer and LINK
// to the relevant Policies section (the anchors live on src/pages/Policies/
// Policies.js) — we never restate the rule here, so the two pages can't drift.

// The three on every workshop detail page ("Good to know").
export const workshopFaqs = [
	{
		q: 'Do we need to be current CYV students?',
		a: 'Not at all. Every workshop is open to all families — current students and newcomers alike. No prior experience needed, just curiosity.',
	},
	{
		q: 'How do we register and pay?',
		a: "Registration is online and self-serve. Spots are limited and confirmed once payment is complete — you'll get a confirmation email right away.",
	},
	{
		q: 'Have a question before signing up?',
		a: "Email sing@coloryourvoice.com or call (952) 283-0560 — we're happy to help you find the right fit.",
	},
];

// The general FAQ page (/faq). Policy-touching answers link into Policies.
export const generalFaqs = [
	{
		q: 'Do we need to be current students?',
		a: 'Not at all. Every workshop and class is open to all families, current students and newcomers alike. No experience needed, just curiosity.',
	},
	{
		q: 'How do we register and pay?',
		a: (
			<>
				Summer workshops register online and self-serve — spots are
				confirmed once payment is complete. Summer private lessons book
				through the Parent/Student Portal. (Details: see Summer Programs in
				our <Link to='/policies#summer-registration'>Policies</Link>.)
			</>
		),
	},
	{
		q: 'What ages are workshops for?',
		a: 'It varies by workshop — each workshop page lists its age range and times.',
	},
	{
		q: 'What if my child misses a lesson?',
		a: (
			<>
				School-year lessons need 24 hours' notice for a makeup credit,
				subject to availability. Full details in our{' '}
				<Link to='/policies#makeups'>makeup &amp; cancellation policy</Link>.
			</>
		),
	},
	{
		q: 'Can I get a refund on a workshop?',
		a: (
			<>
				Yes — full refund if you cancel at least 14 days before the workshop
				starts, or within 48 hours of registering, whichever is later. After
				that, it's non-refundable. See{' '}
				<Link to='/policies#summer-refunds'>workshop refunds</Link> for
				specifics.
			</>
		),
	},
	{
		q: 'Do you offer lessons in the summer?',
		a: 'Yes — summer lessons are optional and billed separately from the school year. Book through the Portal.',
	},
	{
		q: 'How is school-year tuition structured?',
		a: (
			<>
				A flat {TUITION_SEASON_TOTAL_LABEL} for the school year, split across{' '}
				{TUITION_INSTALLMENTS} monthly payments. See{' '}
				<Link to='/policies#tuition'>tuition details</Link>.
			</>
		),
	},
	{
		q: 'Have a question before signing up?',
		a: "Email sing@coloryourvoice.com or call (952) 283-0560 — we're happy to help you find the right fit.",
	},
];
